// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__37knn","messages":"Chat_messages__1zq5J","dateDivider":"Chat_dateDivider__7TLgt"};